import { storyblokDataAttributes } from "@commerce-frontend/storyblok-preview/component";
import { graphql } from "@commerce-frontend/types";
import { cn } from "@commerce-frontend/ui/helpers/styles";
import type { ResultOf } from "@graphql-typed-document-node/core";
import type { HTMLAttributes } from "react";

export const DividerFragment = graphql(/* GraphQL */ `
	fragment DividerFragment on Divider {
		__typename
		id
	}
`);

type DividerBlockProps = {
	data?: ResultOf<typeof DividerFragment>;
} & HTMLAttributes<HTMLDivElement>;

export const Divider = ({ className, data, children }: DividerBlockProps) => {
	return (
		<div className={cn(["relative", className])} {...(data ? storyblokDataAttributes(data) : {})}>
			<hr
				className={cn(["h-px border-0 bg-gray-200", children && "absolute top-1/2 -z-10 w-full"])}
			/>
			{children ? (
				<div className="w-full text-center">
					<div className="inline-block size-fit bg-white px-md">{children}</div>
				</div>
			) : null}
		</div>
	);
};
